<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('key.psd')" center :width="sceneType&&orderId?'800px':'520px'"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p" :class="sceneType&&orderId?'df-c-ct':'df-l-c-sb'">

          <div class="left df-l-fs">

            <InputCustom
              :inputable="true"
              :showPassword="true"
              inputWidth="340"
              :inputPlaceholder="$t('key.inputPsd')"
              :inputValue="password" />

            <div class="reason" v-if="sceneType&&orderId">
              <div class="reason-title f-dark" :class="{'_redcolor':active}">{{$t('key.selectReason')}}</div>
              <div class="reason-content df-w-c-sb">
                <div v-for="(x1,i1) in reasons" :key="i1" class="reason-item df-c-fs" @click="x1.select=!x1.select">
                  <img style="width:20px;height:20px;margin-right:16px;" mode="aspectFill" :src="x1.select?iconCheckok:iconChecknull" />
                  <div class="reason-label f-dark f-xs">{{x1['name'+_lang]}}</div>
                </div>
              </div>
            </div>

          </div>
          
          <div class="right f1 df-fe-ct mt20" :class="{'border':sceneType&&orderId}">
            <Keyboard :inputValue.sync="password" :maxLength="6" />
          </div>

        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <template v-if="showChangePayway">
          <div class="whitebtn" @click="changeCalcway">{{$t('calc.changePayTypeAfterPaid')}}</div>
        </template>
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Keyboard from '@/components/Keyboard'
import InputCustom from '@/components/InputCustom'
export default {
  name: 'DialogKey',
  components: { Keyboard, InputCustom },
  data() {
    return {
      isShowDialog: false,
      password: '',
      reasons: [],
      // reasons: [
      //   { key: 'reason1', id: 1, select: false }, // 客人退菜
      //   { key: 'reason2', id: 2, select: false }, // 库存不足
      //   { key: 'reason3', id: 3, select: false }, // 服务员错误操作
      //   { key: 'reason4', id: 4, select: false }, // 其他
      // ],
      active: false,

      orderId: '',
      sceneType: '', // 1退款/撤销结账 2删除菜品 3删除订单 4取消开台 5修改菜品
      showChangePayway: false,
      onConfirm: null,
      onChange: null,
    }
  },
  methods: {
    open(obj = {}) {
      this.scan_canLeave_x_save(false)

      const {
        orderId = '',
        sceneType = '',
        showChangePayway = false,
        onConfirm = null,
        onChange = null,
      } = obj
      this.orderId = orderId
      this.sceneType = sceneType
      this.showChangePayway = showChangePayway
      this.onConfirm = onConfirm
      this.onChange = onChange

      if (sceneType) {
        this.reasons = this.reasonTemp_x.filter(x1 => x1.typeList.includes(sceneType))
      } else {
        this.reasons = []
      }

      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.password = ''
    },
    async submit() {
      if (this.password) {
        // this.$emit('submitDialog')
        let rD = { secondaryPassword: this.password }
        this.$api.password_verify(rD).then(async res => {
          if (res.status == 0) {

            // 如果需要理由 在這裡統一處理
            if (this.sceneType && this.orderId) {
              let cancelTypeList = this.reasons.filter(x => x.select).map(x => x.id)
              // console.log(`%c取消原因列表:`, 'color: #00f;', cancelTypeList)
              if (cancelTypeList.length) {
                this.active = false
                
                let rD = {
                  shopId: this.currentShopId,
                  type: this.sceneType,
                  cancelTypeList,
                  orderId: this.orderId,
                  managerOpt: this.password.length === 6
                }
                const _D = await this.newData('reason', rD)
                if (_D) {
                  this.close()
                  this.onConfirm && this.onConfirm(this.password)
                  this.reasons.forEach(x => {
                    x.select = false
                  })
                }
              } else {
                this.active = true
              }
            } else {
              this.close()
              this.onConfirm && this.onConfirm(this.password)
            }

          } else { this._status(res) }
        })
      }
    },

    // #region 改变支付渠道
    changeCalcway() {
      console.log(this.onChange)
      this.onChange && this.onChange()
    },
    // #endregion
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 20px 0;box-sizing: border-box;
  .reason{
    width: 366px;margin-top: 20px;
    &-title{padding: 10px 0;}
    &-item{width: 50%;padding: 10px 0;box-sizing: border-box;}
  }
  .border{border-left: 1px solid #979797;}
}
</style>